import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Thumbs, FreeMode } from "swiper";
import { ProductImageSlide } from './ProductImageSlide';

(function init() {
  function loadComponent() {
    const rootElement = document.querySelector("[data-product-images-vertical-slideshow]");
    
    if (rootElement)
      render(
        <ProductImageVerticalSlideshow />,
        rootElement
      );
  }

  document.addEventListener("shopify:section:load", loadComponent);
  loadComponent();
})();

function ProductImageVerticalSlideshow() {
  const [swiper, setSwiper] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const dataContainer = document.querySelector("[data-product-images]");
  if (!dataContainer) return null;
  const product = JSON.parse(dataContainer.innerHTML);

  // Build array of displayed media IDs
  let imageIds = [];
  if (product.selected_or_first_available_variant.featured_media) imageIds.push(product.selected_or_first_available_variant.featured_media.id);
  product.media.forEach((media) => {
    if (media.id !== product.selected_or_first_available_variant.featured_media?.id) imageIds.push(media.id);
  });

  function updateSlide(e) {
    if (swiper) {
      const mediaId = product.variant_images.find((el) => el.variant_id === e.detail.id)?.media_id;
      const indexOfMedia = imageIds.findIndex((id) => id === mediaId);
      swiper.slideTo(indexOfMedia)
    }
  }

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  useEffect(() => {
    document.addEventListener("variant-change", updateSlide);
  }, [swiper, imageIds]);

  return (
    <div className="md:grid grid-cols-6 gap-x-2 product-image-vertical-slideshow md:mt-0">
      <div className="col-span-1 w-full relative overflow-hidden md:block hidden">
        <Swiper
          onSwiper={setThumbsSwiper}
          spaceBetween={8}
          slidesPerView={5}
          modules={[Navigation, Thumbs, FreeMode]}
          direction='vertical'
          autoHeight={true}
          threshold={5}
          className="h-full w-full"
          updateOnWindowResize={true}
        >
          {product.selected_or_first_available_variant.featured_media &&
            <SwiperSlide className="aspect-[5/6] cursor-pointer">
              <img
                src={product.selected_or_first_available_variant.featured_media?.preview_image.src}
                alt={product.selected_or_first_available_variant.featured_media?.alt}
                className="h-full w-full object-center object-cover"
              />

              {product.selected_or_first_available_variant.featured_media.media_type === "video" &&
                <svg className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]" focusable="false" aria-hidden="true" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" fill="black"/>
                  <path d="M23.532 18.3121L15.583 23.6113C15.4107 23.7262 15.1779 23.6797 15.063 23.5074C15.0219 23.4457 15 23.3734 15 23.2993V12.7007C15 12.4936 15.1679 12.3257 15.375 12.3257C15.449 12.3257 15.5214 12.3477 15.583 12.3887L23.532 17.688C23.7043 17.8029 23.7509 18.0358 23.636 18.208C23.6085 18.2492 23.5732 18.2846 23.532 18.3121Z" fill="white"/>
                </svg>
              }
            </SwiperSlide>
          }

          {product.media.map((media) => {
            if (media.id === product.selected_or_first_available_variant.featured_media?.id) return null;

            return (
              <SwiperSlide className="aspect-[5/6] cursor-pointer">
                <img
                  src={media.preview_image.src}
                  alt={media.alt}
                  className="h-full w-full object-center object-cover"
                />
                {media.media_type === "video" &&
                  <svg className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]" focusable="false" aria-hidden="true" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="18" cy="18" r="18" fill="black"/>
                    <path d="M23.532 18.3121L15.583 23.6113C15.4107 23.7262 15.1779 23.6797 15.063 23.5074C15.0219 23.4457 15 23.3734 15 23.2993V12.7007C15 12.4936 15.1679 12.3257 15.375 12.3257C15.449 12.3257 15.5214 12.3477 15.583 12.3887L23.532 17.688C23.7043 17.8029 23.7509 18.0358 23.636 18.208C23.6085 18.2492 23.5732 18.2846 23.532 18.3121Z" fill="white"/>
                  </svg>
                }
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>

      <div className="col-span-5 relative overflow-hidden">
        <Swiper
          onSwiper={setSwiper}
          spaceBetween={8}
          navigation={true}
          thumbs={{ swiper: thumbsSwiper }}
          modules={[Pagination, Navigation, Thumbs]}
          pagination={true}
          onSlideChange={() => {
            thumbsSwiper.slideTo(swiper.activeIndex);
            setCurrentSlideIndex(swiper.realIndex)
          }}
          updateOnWindowResize={true}
        >

          {product.selected_or_first_available_variant.featured_media &&
            <SwiperSlide>
              {({ isActive }) => (
                <ProductImageSlide media={product.selected_or_first_available_variant.featured_media} isActive={isActive} />
              )}
            </SwiperSlide>
          }
          
          {product.media.map((media) => {
            if (media.id === product.selected_or_first_available_variant.featured_media?.id) return null;

            return (
              <SwiperSlide>
                {({ isActive }) => (
                  <ProductImageSlide media={media} isActive={isActive} />
                )}
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
      
    </div>
  )
}